import { motion } from "framer-motion";
import "./certis.css";
import goog from "../Images/googpng.png";
import adob from "../Images/adob.png";

const CERTS = [
    { title: "Foundations of User Experience (UX) Design", org: "Google", logo: goog, url: "https://coursera.org/share/ff7c78650de6c82b2be578c7acaba785" },
    { title: "Image Editing", org: "Adobe", logo: adob, url: "https://coursera.org/share/f60531e4dd4bd02266a56fb440e03399" },
    { title: "Social Media Content and Strategy", org: "Adobe", logo: adob, url: "https://coursera.org/share/1993eace35da1ac4c3013b250bf53137" },
    { title: "UX Research", org: "Google", logo: goog, url: "https://coursera.org/share/824ea1cdc42e6687899e17c93601af12" },
    { title: "Design Fundamentals with AI", org: "Adobe", logo: adob, url: "https://coursera.org/share/e8756aee7ef565f60860ee7a8ad2287e" },
    { title: "Wireframes and Low-Fidelity Prototyping", org: "Google", logo: goog, url: "https://coursera.org/share/e8756aee7ef565f60860ee7a8ad2287e" },
    { title: "Conduct UX Research and Test Early Concepts", org: "Google", logo: goog, url: "https://coursera.org/share/d77bebd580dba37a2c74b31db970276a" },
];

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] } },
};

export default function Certis() {
    return (
        <section className="section certWrap">
            <motion.h3 className="sec-label"
                variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                Certifications
            </motion.h3>
            <motion.p className="sec-statement"
                variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                Certified by <span className="mute">Google &amp; Adobe</span> — mastering UX, design, and digital strategy.
            </motion.p>

            <div className="certGrid">
                {CERTS.map((c) => (
                    <motion.a
                        key={c.title}
                        className="certCard"
                        href={c.url}
                        target="_blank"
                        rel="noreferrer"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        whileHover={{ y: -4 }}
                    >
                        <h4 className="certTitle">{c.title}</h4>
                        <div className="certFooter">
                            <div className="certOrg">
                                <img src={c.logo} alt={c.org} />
                                <span>{c.org}</span>
                            </div>
                            <span className="certArrow">↗</span>
                        </div>
                    </motion.a>
                ))}
            </div>
        </section>
    );
}
